import Vue from 'vue';
import BaseComponent from './baseFormMixin.jsx';
import utils from '../../../Shared/utils.jsx';
import methods from '../../../Shared/methods';

import { appSettings } from '@/Shared/appSettings.js';

Vue.component('sform-textarea', {
    mixins: [BaseComponent],
    data: () => ({
    }),
    props: {
    },
    created() {
    },
    mounted() {
        this.loadComplete();
    },
    computed: {
        placeholder() {
            if (this.element && this.element.schema)
                return this.element.schema.placeholder;
            else
                return undefined;
        },
    },
    methods: {
    },
    render() {
        let scopedSlots = {
            message: ({message}) => {
                return <translation-container context={this} value={message}></translation-container>
            }
        }

        let slots = [
            <translation-container slot="label" context={this} value={this.labelText}></translation-container>,
        ];

        let input =
            <v-textarea
                rows={this.element.formatData ? this.element.formatData.Rows || "4" : "4"}
                class="caption pa-0 ma-0"
                outlined single-line dense hide-details
                style={{ width: "100%" }}
                placeholder={this.Translate(this.placeholder)}
                value={this.itemvalue}
                rules={this.rules}
                on-input={(value) => this.sync(value)}
                on-blur={this.onBlur}
                on-focus={this.onFocus}
                scopedSlots={scopedSlots}
                hint={this.hintText}
                persistent-hint={appSettings.DebugTranslationPrefixSetting}
            >{slots}</v-textarea>;

        if (this.appearance)
            input.componentOptions.propsData = { ...input.componentOptions.propsData, ...this.appearance };

        return input;
    }
});